var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-container"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.value + '%' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }